import config from '../config';

export const pageNames = config.pageNames;

export function setPageTitle(pageName = false, delimiter = false) {
	let title = '';

	if(pageName) {
		title = pageName;
	} else {
		title = config.siteName;
	}

	if(delimiter && pageName) {
		title += config.titleDelimiter + config.siteName;
	}

	return document.title = title;
}



/** WEBPACK FOOTER **
 ** ./src/utils/titleSetter.js
 **/